export default "__VITE_ASSET__J1fTRr8H__"